<template>
    <div id="information-list">
        <span class="headtitle">
            {{ $t("message.defaultContents") }}
        </span>
        <div v-for="(content, index) in getActives()" class="contentInfo">
            <div
                id="fakeDefaultContents"
                v-b-toggle="`shortcut-accordion-${index}`"
                class="contentInfo first"
                data-v-step="20"
                @click="visibleContentId = visibleContentId !== content._id ? content._id : undefined"
            >
                {{ content.languageContent[myDefaultContentLang].name }}
                <span v-if="visibleContentId === content._id" style="float: right; transform: rotate(180deg)"
                    ><downButton
                /></span>
                <span v-else style="float: right"><downButton /></span>
            </div>
            <b-collapse :id="`shortcut-accordion-${index}`" accordion="shortcuts-accordion" role="tabpanel">
                <div
                    v-for="subContent in getChildren(content)"
                    :key="subContent._id"
                    v-tippy="{ followCursor: true, placement: 'bottom-end' }"
                    :class="subContent.type.toLowerCase()"
                    :content="subContent.languageContent[myDefaultContentLang].content"
                    :data-id="subContent._id"
                    :data-letter="subContent.letter"
                    :data-number="subContent.number"
                    class="contentButton"
                    @click="onShortcutSelected(subContent.languageContent[myDefaultContentLang].content)"
                >
                    <div v-if="subContent.type.toLowerCase() === 'alt'" class="contentInfo sec" style="cursor: pointer">
                        {{ isMac ? "CTRL" : "ALT" }} +
                        {{ subContent.letter }}
                    </div>
                    <div v-else-if="subContent.type.toLowerCase() === 'tab'" class="contentInfo sec">
                        {{ subContent.letter }}
                        <right-button />
                        tab
                        <right-button />
                        {{ subContent.number }}
                    </div>
                    <div v-else>{{ $t("message.noShortCut") }}</div>
                    <div class="contentInfo three">
                        {{ subContent.languageContent[myDefaultContentLang].name }}
                    </div>
                </div>
            </b-collapse>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import * as _ from "lodash";
import { CONTENT_TYPES } from "../utils/staticDatas";
import { log2 } from "../utils/log2";
import DownButton from "./svg/DownButton";
import RightButton from "./svg/RightButton";
import { fakeContents, isMac } from "../utils/utils";
import moment from "moment";
import CONFIG from "../config/config";

const log = log2("DefaultContentsWidget");
export default {
    name: "DefaultContentsWidget",
    components: { DownButton, RightButton },
    data() {
        return {
            visibleContentId: undefined,
            isMac,
        };
    },
    computed: {
        ...mapState({
            contents: (state) => (state.app.fakeMode ? fakeContents() : state.content.contents),
            fakeMode: (state) => state.app.fakeMode,
            activeConversation: (state) =>
                state.app.fakeMode ? state.chat.fakeActiveConversation : state.chat.activeConversation,
            myLang: (state) => state.auth.user.lang,
            myDefaultContentLang: (state) =>
                CONFIG.SUPPORTED_LANGS.includes(state.auth.user.lang)
                    ? state.auth.user.lang
                    : CONFIG.SUPPORTED_LANGS(state.chat.activeConversation.languageCode)
                    ? state.chat.activeConversation.languageCode
                    : "tr",
        }),
        ...mapGetters({
            grouped: "content/getGrouped",
            isDarkMode: "user/isDarkMode",
        }),
    },
    mounted() {
        log("grouped", this.grouped);
    },
    updated() {
        log("grouped", this.grouped);
    },
    methods: {
        getChildren(content) {
            const item = _.cloneDeep(content);
            let items = item.children || [];
            items.push({
                ...item,
                children: undefined,
            });
            items = _.uniqBy(items, (q) => q._id).filter((x) => x.type !== CONTENT_TYPES.TITLE);
            log(
                "getChildren",
                content.languageContent.tr.name,
                items.map((x) => x.languageContent.tr.name),
                content
            );
            items = items.filter((x) => x.isActive);
            return items;
        },

        getActives() {
            const grouped = this.fakeMode ? this.getGrouped(fakeContents()) : this.grouped;
            return grouped.filter((x) => x.isActive && x.children.length !== 0);
        },

        getGrouped(contents) {
            const parents = contents.filter((c) => c.parentId === null);
            //parentId si var fakat o parentId'de kimse yoksa bunlarda kendi başına bir parent olarak kabul ediliyor
            const maybeOtherParents = _.difference(contents, parents).filter(
                (item) => contents.filter((x) => x._id === item.parentId).length === 0
            );

            maybeOtherParents.forEach((x) => {
                x.parentId = null;
            });
            const allParents = [...parents, ...maybeOtherParents];
            allParents.forEach((p, k) => {
                allParents[k].children = contents.filter((c) => c.parentId === p._id) || [];
            });

            return _.sortBy(allParents, (q) => -moment(q.createdAt).valueOf());
        },
    },
    props: {
        onShortcutSelected: {
            type: Function,
            default: () => {},
        },
    },
};
</script>

<style lang="scss">
.new-theme {
    #information-list {
        overflow-y: auto;
        background-color: #ffffff;
        padding: 20px;
        margin-bottom: 0px;
        height: calc(100vh - 180px);
        box-shadow: 0 0 3px #00000080;
        z-index: 9;
        border-radius: 6px;

        ul {
            margin-block-end: 0;

            li {
                label {
                    font-family: Poppins;
                    font-size: 12px;
                    font-weight: 700;
                    color: #3699ff !important;
                }
            }
        }

        .headtitle {
            font-size: 18px;
            color: #101217;
            margin-bottom: 10px;
            display: block;
        }

        .card {
            /*margin-top: 20px;*/
            border: none;

            .card-header {
                border: none;
                background-color: #ffffff;
            }

            .card-body {
                background-color: #ffffff;

                ul {
                    list-style: none;
                }
            }
        }
    }

    .contentHeader {
        color: #181c32;
        font-family: Poppins;
        font-weight: 300;
        text-align: left;
        font-size: 14px;
        cursor: pointer;
        border-bottom: 1px solid #3699ff;
    }

    .shortcutButton {
        background-color: #eaecf2;
        font-family: Poppins;
        font-weight: 700;
        font-size: 12px;
        cursor: pointer;
        padding: 3px 10px;
        border-radius: 6px;
    }

    .contentInfo {
        font-family: Poppins;

        &.first {
            color: #181c32;
            font-size: 16px;
            font-weight: 300;
            border-bottom: 1px solid #3699ff;
            padding-bottom: 5px;
            margin-bottom: 3px;
        }

        &.sec {
            color: #3699ff;
            font-size: 14px;
            font-weight: 300;
            padding-top: 5px;
            background-color: #eaecf2;
            text-align: center;
            border-radius: 3px;
            padding: 5px 5px 5px 5px;
            white-space: nowrap;
        }

        &.three {
            color: #181c32;
            font-size: 14px;
            font-weight: 300;
            padding-top: 5px;
            display: block;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            padding-left: 5px;
        }
    }

    .contentButton {
        display: flex;
        justify-content: flex-start;
        padding-top: 5px;
    }
}
</style>
